import createHistory from 'history/createBrowserHistory';
import { stripRoutingSegment } from '../utils/uriUtils';

export class FindingRouter {
    constructor(options) {
        const { routes, initialUriRef } = options;

        this.routes = routes;
        this.history = createHistory();
        this.previousDisplayUriRef = initialUriRef;
    }

    navigate(displayUriRef) {
        const { pathname, search } = this.history.location;
        const currentUriRef = stripRoutingSegment(`${pathname}${search}`); // what's currently in the browser address bar

        if (displayUriRef !== currentUriRef) {
            //update browser url bar if URI changes in the store
            this.history.push(displayUriRef);
            // keep track of previous push so we don't push any history twice
            this.previousDisplayUriRef = displayUriRef;
        }
    }
}
